import React from 'react';
import Modal from 'react-bootstrap/Modal';


const Spinner = ({ show }) => {
    if (!show) return null;

    return (<>
        <Modal show={true} fullscreen={false} centered style={{ height: "auto" }}>
            <Modal.Body>
                <div id="spinner" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div className="text-center">
                        <div className="spinner-border m-3" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <div className="m-3" >
                            <strong>Por favor espera...</strong>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    </>
    );
}

export default Spinner;
